var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-layer-settings"},[_c((_vm.layerType + "-settings"),{tag:"component",attrs:{"id":_vm.settingsId}}),_c('settings-close-button',{on:{"close":_vm.closeSettings}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }